var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgMessageCircleFilled16 = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.3 12.09c3.038 0 5.5-2.034 5.5-4.545C13.8 5.035 11.339 3 8.3 3 5.264 3 2.8 5.035 2.8 7.545c0 1.024.41 1.968 1.1 2.728L2.8 13l2.753-1.516a6.382 6.382 0 0 0 2.748.607Z"
  })));
});
SvgMessageCircleFilled16.displayName = "SvgMessageCircleFilled16";
export default SvgMessageCircleFilled16;